import { useState } from "react";
import { useNavigate } from "react-router-dom";
import OverviewTab  from "./tabs/OverviewTab";
import PostsTab     from "./tabs/PostsTab";
import AboutTab     from "./tabs/AboutTab";
import ProjectsTab  from "./tabs/ProjectsTab";
import StorageTab     from "./tabs/StorageTab";
import LandownersTab  from "./tabs/LandownersTab";

const TABS = [
  { id:"overview",   label:"📊 Overview"   },
  { id:"posts",      label:"📰 Posts"      },
  { id:"about",      label:"ℹ️ About"      },
  { id:"projects",   label:"🏗️ Projects"  },
  { id:"landowners", label:"👥 Landowners" },
  { id:"storage",    label:"☁️ Storage"   },
];

export default function AdminDashboard({ onLogout }) {
  const [tab,       setTab]       = useState("overview");
  const [msg,       setMsg]       = useState(null);   /* { text, type: "ok"|"err" } */
  const [uploading, setUploading] = useState(false);
  const navigate = useNavigate();

  /** Green success banner — auto-dismisses after 3 s */
  const flash = text => {
    setMsg({ text, type: "ok" });
    setTimeout(() => setMsg(null), 3000);
  };

  /** Red error banner — stays until user dismisses or next action */
  const flashError = text => {
    setMsg({ text, type: "err" });
  };

  const bannerStyle = type => ({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    borderRadius: 10,
    padding: ".7rem 1.1rem",
    marginBottom: "1.1rem",
    fontWeight: 700,
    fontSize: ".87rem",
    ...(type === "ok"
      ? { background:"#e8f5e9", border:"1.5px solid #a5d6a7", color:"#2e7d32" }
      : { background:"#ffebee", border:"1.5px solid #ef9a9a", color:"#c62828" }),
  });

  return (
    <div className="admin-wrap">
      <div className="sidebar">
        <div className="sidebar-hdr">
          <div className="s1">LHDA Inc.</div>
          <div className="s2">Content Manager</div>
        </div>
        {TABS.map(t => (
          <button key={t.id}
            className={`sb-lnk${tab === t.id ? " on" : ""}`}
            onClick={() => { setTab(t.id); setMsg(null); }}>
            {t.label}
          </button>
        ))}
        <div style={{ borderTop:"1px solid rgba(255,255,255,.14)", margin:"1rem 0" }}/>
        <button className="sb-lnk" onClick={() => navigate("/")}>🌐 View Website</button>
        <button className="sb-lnk" onClick={async () => { await onLogout(); navigate("/"); }}>🚪 Sign Out</button>
      </div>

      <div className="admin-main">
        {/* Upload progress */}
        {uploading && (
          <div style={{ background:"#e3f2fd", border:"1.5px solid #90caf9", borderRadius:10,
                        padding:".7rem 1.1rem", marginBottom:"1.1rem", color:"#1565c0",
                        fontWeight:700, fontSize:".87rem" }}>
            ⏳ Uploading image to Firebase Storage…
          </div>
        )}

        {/* Success / error banner */}
        {msg && !uploading && (
          <div style={bannerStyle(msg.type)}>
            <span>{msg.type === "ok" ? "✓" : "✗"} {msg.text}</span>
            {msg.type === "err" && (
              <button onClick={() => setMsg(null)}
                style={{ background:"none", border:"none", cursor:"pointer",
                         color:"#c62828", fontWeight:900, fontSize:"1rem", lineHeight:1 }}>
                ×
              </button>
            )}
          </div>
        )}

        {tab === "overview" && <OverviewTab/>}
        {tab === "posts"    && <PostsTab    flash={flash} flashError={flashError} uploading={uploading} setUploading={setUploading}/>}
        {tab === "about"    && <AboutTab    flash={flash} flashError={flashError} uploading={uploading} setUploading={setUploading}/>}
        {tab === "projects"   && <ProjectsTab   flash={flash}/>}
        {tab === "landowners" && <LandownersTab flash={flash} flashError={flashError} uploading={uploading} setUploading={setUploading}/>}
        {tab === "storage"    && <StorageTab    flash={flash} flashError={flashError}/>}
      </div>
    </div>
  );
}
